
import { defineComponent, inject } from 'vue';
import { useStore } from 'vuex'
import moment from 'moment';
import BlogTag from '../components/BlogTag.vue'
import BlogSpHeader from '../components/BlogSpHeader.vue'

export default defineComponent({
  name: 'BlotTop',
  inject: ['$C'],
  components: { BlogTag, BlogSpHeader },
  setup() {
    const store = useStore()
    const postIndex = store.getters.getPostIndex()
    const convertDate = (dt: string): string => {
      return moment(Date.parse(dt)).format('YYYY/MM/DD')
    }
    return {
      postIndex,
      convertDate,
    }
  }
});
